import { makeStyles } from '@material-ui/core';
import React from 'react';
import Footer from './footer';
import Header, { HeaderLink } from './header';

type PageLayoutProps = {
  className?: string;
  headerClassName?: string;
  showFooterHero?: boolean;
  footerGradientHeight?: number;
  footerGradientColor?: 'green' | 'teal';
  mobileLinks?: HeaderLink[];
};

const useStyles = makeStyles(theme => ({
  content: (props: PageLayoutProps) => ({
    position: 'relative',
  }),
  gradient: (props: PageLayoutProps) => ({
    display: props.footerGradientHeight ? 'block' : 'none',
    background:
      props.footerGradientColor === 'green'
        ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(153, 229, 197, 0.2) 50%, rgba(0, 190, 111, 0.2) 100%)'
        : 'linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(103, 191, 183, 0.2) 50%, rgba(0, 155, 141, 0.2) 100%)',
    position: 'absolute',
    width: '100%',
    height: theme.spacing(props.footerGradientHeight || 0),
    bottom: -theme.spacing(props.footerGradientHeight || 0),
    zIndex: -1,
  }),
}));

const PageLayout: React.FC<PageLayoutProps> = props => {
  const classes = useStyles(props);
  const { children, showFooterHero, headerClassName } = props;
  const className = `${classes.content} ${props.className}`;
  const links: HeaderLink[] = [
    {
      label: 'Product',
      children: [
        {
          label: 'Overview',
          path: '/product/overview/',
        },
        {
          label: 'Application delivery',
          path: '/product/application-delivery/',
        },
        {
          label: 'Environment provisioning',
          path: '/product/environment-provisioning/',
        },
        {
          label: 'Service discovery',
          path: '/product/service-discovery/',
        },
        {
          label: 'Network security',
          path: '/product/network-security/',
        },
        {
          label: 'Compliance',
          path: '/product/compliance/',
        },
        {
          label: 'Credential issuance (coming soon)',
          path: '/product/credential-issuance/',
        },
      ],
    },
    {
      label: 'Use cases',
      children: [
        {
          label: 'Self-service deployments',
          path: '/use-cases/self-service-deployments/',
        },
        {
          label: 'Private developer environments',
          path: '/use-cases/private-developer-environments/',
        },
        {
          label: 'Preview environments',
          path: '/use-cases/preview-environments/',
        },
        {
          label: 'Service catalog',
          path: '/use-cases/service-catalog/',
        },
        {
          label: 'Security & compliance',
          path: '/use-cases/security-compliance/',
        },
      ],
    },
    {
      label: 'Documentation',
      path: '/docs/',
    },
    { label: 'Pricing', path: '/pricing/' },
    {
      label: 'Company',
      children: [
        {
          label: 'Careers',
          path: '/careers/',
        },
        {
          label: 'Blog',
          path: '/blog/',
        },
        {
          label: 'Contact us',
          path: '/contact-us/',
        },
      ],
    },
  ];

  return (
    <>
      <Header links={links} mobileLinks={props.mobileLinks} className={headerClassName} />
      <div className={className}>
        <div className={classes.gradient} />
        {children}
      </div>
      <Footer
        showGettingStartedBlock={showFooterHero}
        gettingStartedNegativeMargin={props.footerGradientHeight}
      />
    </>
  );
};

PageLayout.defaultProps = {
  footerGradientHeight: 30,
  footerGradientColor: 'green',
};

export default PageLayout;
